"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateStoredValueArray = exports.isComplete = exports.isChecked = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var isChecked = function determineIfControlIsChecked(storedValue, option) {
  return storedValue.indexOf(option.value) > -1;
};

exports.isChecked = isChecked;

var isComplete = function isCheckboxInputComplete(isValid, complete) {
  return complete || isValid;
};

exports.isComplete = isComplete;

var updateStoredValueArray = function checkboxInputUpdateStoredValueArray(selectedValue, storedValue) {
  var storedValueIndex = storedValue.indexOf(selectedValue);

  if (storedValueIndex === -1) {
    return [].concat((0, _toConsumableArray2["default"])(storedValue), [selectedValue]);
  }

  return [].concat((0, _toConsumableArray2["default"])(storedValue.slice(0, storedValueIndex)), (0, _toConsumableArray2["default"])(storedValue.slice(storedValueIndex + 1)));
};

exports.updateStoredValueArray = updateStoredValueArray;